import React, { useEffect, useMemo, useState } from "react";
import {portraitImageData, landscapeImageData} from "./data/hero";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio/Portfolio";
import Contact from "./components/Contact";

export default function App() {
  const [dark, setDark] = useState(true);
  const [activeSection, setActiveSection] = useState("hero");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => { const root = document.documentElement; if (dark) root.classList.add("dark"); else root.classList.remove("dark"); }, [dark]);
  // pick dataset
  const imageData = useMemo(
      () => (isMobile ? portraitImageData : landscapeImageData),
      [isMobile]
  );

  const [heroIndex, setHeroIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(
        () => setHeroIndex((i) => (i + 1) % imageData.hero.images.length),
        6000
    );
    return () => clearInterval(timer);
  }, [imageData.hero.images.length]);
  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveSection(entry.target.id);
            }
          });
        },
        { threshold: 0.5 } // 50% of section visible = active
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);


  // Scroll by ID (unchanged)
  const scrollToId = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
      <div className="h-dvh w-screen overflow-y-scroll snap-y snap-mandatory bg-neutral-50 text-neutral-900 selection:bg-neutral-900 selection:text-white dark:bg-neutral-950 dark:text-neutral-100">
      <Header
            dark={dark}
            setDark={setDark}
            scrollToId={scrollToId}
            isFullscreen={activeSection === "portfolio"} // 👈 hide in portfolio
        />

        <section id="hero" className="snap-start h-dvh">
          <Hero imageData={imageData} heroIndex={heroIndex} />
        </section>

        <section id="portfolio" className="snap-start h-dvh">
          <Portfolio imageData={imageData} />
        </section>

        <section id="contact" className="snap-start h-dvh">
          <Contact/>
        </section>
      </div>
  );
}
